import React, { useContext, useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import MonitoringTitleBar from "./MonitoringTitleBar";
import MonitoringCallInfoContainer from "./MonitoringCallInfo/MonitoringCallInfoContainer";
import Box from "@mui/material/Box";
import { MsalContext } from "../Contexts/MsalContext";
import CircularProgress from "@mui/material/CircularProgress";
import { APIContext } from "../Contexts/APIContext";
import { RecordingInfoViewModel } from "../ViewModels/RecordingViewModel";
import SingleCallWavBar from "./SingleCallWavBar";
import TranscriptSearch from "./Transcripts/TranscriptSearch";
import TranscriptTab from "./Transcripts/TranscriptTab";
import MonitoringScoreCard from "./MonitoringScoreCard";

const styles = {
    fullHeight: {
        height: '100%'
    },
    singleFrame: {
        float: 'left'
    },
    bgColour: {
        backgroundColor: 'rgb(245, 245, 245)'
    }
};

interface IProps {
    id: string;
    setId: (newId: string) => void
    close: () => void;
    agentView?: boolean;
    transcriptSearch?: TranscriptSearch;
    mainView?: boolean;
    showBackButton: boolean;
}

export default function MonitoringContainer(props: IProps) {
    const { msalFetch } = useContext(MsalContext);
    const [isDataDialler, setisDataDialler] = useState<boolean>(false);
    const { isAdmin, isExec, isQA, isTeamLeader, isResqAnywhere, isClientTranscriptsEnabled } = useContext(APIContext);
    const [isClient, setIsClient] = useState<boolean>(false);
    const [selectedCallIndex, setSelectedCallIndex] = useState<number>(0);
    const [recordings, setRecordings] = useState<RecordingInfoViewModel | null>(null);
    const [isUsersCall, setIsUsersCall] = useState<boolean>(false);

    useEffect(() => {
        fetchData();
    }, [props.id])

    const getRecordingsInfo = () => {
        msalFetch(`api/Info/GetRecordingsInfo?systemPk=${props.id}`)
            .then(response => response.json())
            .then(data => setRecordings(data))
    }

    const checkIfDataDialler = () => {
        msalFetch('api/User/IsDataDialler')
            .then(response => response.json())
            .then(data => {
                setisDataDialler(data);
            });
    }

    const checkIfClient = () => {
        msalFetch('api/User/IsClient')
            .then(response => response.json())
            .then(data => {
                setIsClient(data);
            });
    }

    const checkIsUsersCall = () => {
        msalFetch(`api/MonitoringCallInfo/CheckIsUsersCall?callRefid=${props.id}`)
            .then(response => response.json())
            .then(data => setIsUsersCall(data.value));
    }

    const fetchData = () => {
        if (props.agentView) {
            checkIsUsersCall();
        }
        checkIfDataDialler();
        checkIfClient();
        getRecordingsInfo();
    }

    const callInfoAndTitlebar =
        <Box display="flex" flexDirection="column" sx={styles.fullHeight}>
            <MonitoringTitleBar
                id={props.id}
                close={props.close}
                isQA={isQA}
                isClient={isClient}
                isAdmin={isAdmin}
                isDataDialler={isDataDialler}
                isUsersCall={props.agentView ? isUsersCall : undefined}
                showBackButton={props.showBackButton} />
            <Box flexGrow={1} overflow="auto">
                <MonitoringCallInfoContainer
                    id={props.id}
                    setId={props.setId}
                    setSelectedCallIndex={setSelectedCallIndex}
                    agentView={props.agentView}
                    mainView={props.mainView}
                    transcriptSearch={props.transcriptSearch}
                    recordings={recordings!}
                    isUsersCall={props.agentView ? isUsersCall : undefined}
                />
            </Box>
        </Box>

    return (recordings !== null ?
        <Box display="flex" sx={{ ...styles.fullHeight, ...styles.bgColour }} flexDirection="column"  >
            <Box flexGrow={1} overflow="auto">
                {((isQA || isAdmin || isTeamLeader || isExec || props.agentView) && isResqAnywhere() && !isClient) ?
                    <Grid container sx={styles.fullHeight}>
                        <Grid size={props.agentView ? 6 : 7.2} sx={styles.fullHeight}>
                            {
                                callInfoAndTitlebar
                            }
                        </Grid>
                        {props.agentView ?
                            <Grid size={6} sx={styles.fullHeight}>
                                <MonitoringScoreCard
                                    callRefId={props.id}
                                    agentView={props.agentView}
                                    isUsersCall={props.agentView ? isUsersCall : undefined}
                                    isTeamLeader={isTeamLeader}
                                />
                            </Grid>
                            :
                            <Grid size={4.8} sx={styles.fullHeight}>
                                <TranscriptTab
                                    id={props.id!}
                                    switchCallId={recordings.recordings.length === 0 ? undefined : recordings.recordings[selectedCallIndex].switchCallID}
                                    transcriptSearch={props.transcriptSearch}
                                    mainView={props.mainView}
                                />
                            </Grid>
                        }
                    </Grid >
                    : (isClient && !isClientTranscriptsEnabled) ?
                    <Grid container sx={styles.fullHeight}>
                        <Grid size={12} sx={styles.fullHeight}>
                            {
                                callInfoAndTitlebar
                            }
                        </Grid>
                    </Grid >
                    :
                    <Grid container sx={styles.fullHeight}>
                        <Grid size={6} sx={styles.fullHeight}>
                            {
                                callInfoAndTitlebar
                            }
                        </Grid>
                        <Grid size={6} sx={styles.fullHeight}>
                            <TranscriptTab
                                id={props.id!}
                                switchCallId={recordings.recordings.length === 0 ? undefined : recordings.recordings[selectedCallIndex].switchCallID}
                                transcriptSearch={props.transcriptSearch}
                                mainView={props.mainView}
                            />
                        </Grid>
                    </Grid >
                }
            </Box>
            {
                !props.agentView &&
                <SingleCallWavBar agentView={props.agentView} recording={recordings.recordings.length === 0 ? undefined : recordings.recordings[selectedCallIndex]} />
            }
        </Box >
        :
        <Grid container justifyContent="center" alignItems="center" height="100vh">
            <Grid>
                <CircularProgress size={250} />
            </Grid>
        </Grid>
    );
}